// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.inputDialogRoot[data-v-475007f2]
	{
		max-width: calc(100vw - 40px);
		background-color: #FFFFFF;
}
.titleBar[data-v-475007f2]
	{
		background-color: #FFFFFF;
		padding: 8px 14px;
		box-sizing: border-box;
}
.title[data-v-475007f2]
	{
		text-align: center;
		color: black;
		font-weight: bold;
		font-size: 16pt;
}
.dialogBody[data-v-475007f2]
	{
		padding: 0px 5px 0px 5px;
}
.conflictsContainer[data-v-475007f2]
	{
		margin-top: 1em;
}
.conflict[data-v-475007f2]
	{
		margin-bottom: 1em;
}
.conflict[data-v-475007f2]:last-of-type
		{
			margin-bottom: 0px;
}
.conflictPath[data-v-475007f2]
	{
		font-weight: bold;
		margin-bottom: 1em;
		background-color:;
}
.conflictValue[data-v-475007f2]
	{
		border: 3px solid #E3E3E3;
		border-left-width: 10px;
		margin-bottom: 0.6em;
		white-space: pre-wrap;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		border-radius: 5px;
		/*box-shadow: -1px -1px 8px 1px rgba(0,0,0,0.4) inset;*/
}
.conflictValue.noneSelected[data-v-475007f2]
		{
}
.conflictValue.selected[data-v-475007f2]
		{
			border-color: #000000;
			box-shadow: 1px 1px 8px 2px rgba(0,0,0,1);
			outline: 1px solid black;
}
.conflictValue[data-v-475007f2]:hover,
		.conflictValue[data-v-475007f2]:focus
		{
			outline: 4px solid black;
}
.valueHeader[data-v-475007f2]
	{
		font-size: 1.125em;
		background-color: #E3E3E3;
}
.conflictValue.selected .valueHeader[data-v-475007f2]
	{
		background-color: #000000;
		color: #FFFFFF;
		font-weight: bold;
}
.conflictText[data-v-475007f2]
	{
		padding: 0px 6px 8px 6px;
}

	/*.baseValue
	{
		border-color: #DDDDCD;
	}

		.baseValue .valueHeader
		{
			background-color: #DDDDCD;
		}

	.yourValue
	{
		border-color: #D4D4DD;
	}

		.yourValue .valueHeader
		{
			background-color: #D4D4DD;
		}

	.theirValue
	{
		border-color: #D4DDD4;
	}

		.theirValue .valueHeader
		{
			background-color: #D4DDD4;
		}*/
.baseValue.selected[data-v-475007f2]
	{
		border-color: #ffff00;
}
.baseValue.selected .valueHeader[data-v-475007f2]
		{
			background-color: #ffff00;
			color: #000000;
}
.yourValue.selected[data-v-475007f2]
	{
		border-color: #7de3ff;
}
.yourValue.selected .valueHeader[data-v-475007f2]
		{
			background-color: #7de3ff;
			color: #000000;
}
.theirValue.selected[data-v-475007f2]
	{
		border-color: #6fff6f;
}
.theirValue.selected .valueHeader[data-v-475007f2]
		{
			background-color: #6fff6f;
			color: #000000;
}
.buttons[data-v-475007f2]
	{
		display: flex;
}
.dialogButton[data-v-475007f2]
	{
		margin: 0px;
		border: none;
		display: inline-block;
		cursor: pointer;
		background-color: #FFFFFF;
		color: black;
		font-weight: bold;
		font-size: 12pt;
		box-sizing: border-box;
		position: relative;
		padding: 12px 5px;
		flex: 1 0 auto;
		text-align: center;
}
.dialogButton[data-v-475007f2]:hover
		{
			background-color: rgba(0,0,0,0.05);
}
.okButton[data-v-475007f2]
	{
		color: #4A9E42;
}
.cancelButton[data-v-475007f2]
	{
		color: #CE7D29;
		border-left: 1px solid #DDDDDD;
}
.dialogButton[data-v-475007f2]:disabled
	{
		opacity: 0.48;
		background-color: rgba(0,0,0,0.05);	
		color: black;
		cursor: default;
		cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./www/vues/common/controls/MergeConflictsPopup.vue"],"names":[],"mappings":";AA8KC;;EAEC,6BAA6B;EAC7B,yBAAyB;AAC1B;AAEA;;EAEC,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACvB;AAEA;;EAEC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AAChB;AAEA;;EAEC,wBAAwB;AACzB;AAEA;;EAEC,eAAe;AAChB;AAEA;;EAEC,kBAAkB;AACnB;AAEC;;GAEC,kBAAkB;AACnB;AAED;;EAEC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AAClB;AAEA;;EAEC,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uDAAuD;AACxD;AAEC;;AAEA;AAEA;;GAEC,qBAAqB;GACrB,yCAAyC;GACzC,wBAAwB;AACzB;AAEA;;;GAGC,wBAAwB;AACzB;AAGD;;EAEC,kBAAkB;EAClB,yBAAyB;AAC1B;AAEA;;EAEC,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AAClB;AAEA;;EAEC,wBAAwB;AACzB;;CAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA4BG;AAEH;;EAEC,qBAAqB;AACtB;AAEC;;GAEC,yBAAyB;GACzB,cAAc;AACf;AAGD;;EAEC,qBAAqB;AACtB;AAEC;;GAEC,yBAAyB;GACzB,cAAc;AACf;AAED;;EAEC,qBAAqB;AACtB;AAEC;;GAEC,yBAAyB;GACzB,cAAc;AACf;AAED;;EAEC,aAAa;AACd;AAEA;;EAEC,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACnB;AAEC;;GAEC,kCAAkC;AACnC;AAED;;EAEC,cAAc;AACf;AAEA;;EAEC,cAAc;EACd,8BAA8B;AAC/B;AAEA;;EAEC,aAAa;EACb,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,mBAAmB;AACpB","sourcesContent":["<template>\r\n\t<div :class=\"{ inputDialogRoot: true }\" ref=\"dialogRoot\" role=\"dialog\" aria-labelledby=\"mergeConflictsTitle\" aria-describedby=\"mergeConflictsMsg\">\r\n\t\t<div class=\"titleBar\">\r\n\t\t\t<div id=\"mergeConflictsTitle\" class=\"title\" role=\"alert\">Merge Conflicts</div>\r\n\t\t</div>\r\n\t\t<div class=\"dialogBody\">\r\n\t\t\t<div id=\"mergeConflictsMsg\" class=\"messageText\">Your changes may conflict with someone else's recent changes.  Please select from the following options for each field:</div>\r\n\t\t\t<div class=\"conflictsContainer\">\r\n\t\t\t\t<div class=\"conflict\" v-for=\"c in mergeConflicts\" :key=\"c.path\">\r\n\t\t\t\t\t<div class=\"conflictPath\">{{c.path}}</div>\r\n\t\t\t\t\t<div class=\"conflictValue baseValue\" :class=\"{ selected: c.selected === 0, noneSelected: c.selected === -1 }\"\r\n\t\t\t\t\t\t tabindex=\"0\"\r\n\t\t\t\t\t\t @click=\"select(c, 0)\"\r\n\t\t\t\t\t\t @keypress.space.enter.prevent=\"select(c, 0)\"\r\n\t\t\t\t\t\t ref=\"baseValue\">\r\n\t\t\t\t\t\t<div class=\"valueHeader\">Original</div>\r\n\t\t\t\t\t\t<div class=\"conflictText\">{{c.baseValue}}</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"conflictValue yourValue\" :class=\"{ selected: c.selected === 1, noneSelected: c.selected === -1 }\"\r\n\t\t\t\t\t\t tabindex=\"0\"\r\n\t\t\t\t\t\t @click=\"select(c, 1)\"\r\n\t\t\t\t\t\t @keypress.space.enter.prevent=\"select(c, 1)\">\r\n\t\t\t\t\t\t<div class=\"valueHeader\">Yours</div>\r\n\t\t\t\t\t\t<div class=\"conflictText\" v-html=\"c.diffYours\"></div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"conflictValue theirValue\" :class=\"{ selected: c.selected === 2, noneSelected: c.selected === -1 }\"\r\n\t\t\t\t\t\t tabindex=\"0\"\r\n\t\t\t\t\t\t @click=\"select(c, 2)\"\r\n\t\t\t\t\t\t @keypress.space.enter.prevent=\"select(c, 2)\">\r\n\t\t\t\t\t\t<div class=\"valueHeader\">Theirs</div>\r\n\t\t\t\t\t\t<div class=\"conflictText\" v-html=\"c.diffTheirs\"></div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"buttons\">\r\n\t\t\t\t<button class=\"dialogButton okButton\" tabindex=\"0\" @click=\"okClicked\" :disabled=\"!okButtonEnabled\">\r\n\t\t\t\t\tOK\r\n\t\t\t\t</button>\r\n\t\t\t\t<button ref=\"cancelBtn\" class=\"dialogButton cancelButton\" tabindex=\"0\" @click=\"cancelClicked\">\r\n\t\t\t\t\tCancel\r\n\t\t\t\t</button>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\timport { makeWhitespaceVisible } from 'appRoot/scripts/Util';\r\n\r\n\texport default {\r\n\t\tprops:\r\n\t\t{\r\n\t\t\tmergeConflicts: {\r\n\t\t\t\ttype: Array,\r\n\t\t\t\trequired: true\r\n\t\t\t}\r\n\t\t},\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t};\r\n\t\t},\r\n\t\tcreated()\r\n\t\t{\r\n\t\t\tfor (let i = 0; i < this.mergeConflicts.length; i++)\r\n\t\t\t{\r\n\t\t\t\tthis.mergeConflicts[i].selected = -1;\r\n\t\t\t}\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t\tokButtonEnabled()\r\n\t\t\t{\r\n\t\t\t\tfor (let i = 0; i < this.mergeConflicts.length; i++)\r\n\t\t\t\t{\r\n\t\t\t\t\tif (this.mergeConflicts[i].selected < 0)\r\n\t\t\t\t\t\treturn false;\r\n\t\t\t\t}\r\n\t\t\t\treturn true;\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tSetFocus()\r\n\t\t\t{\r\n\t\t\t\tif (this.$refs.baseValue)\r\n\t\t\t\t{\r\n\t\t\t\t\tif (this.$refs.baseValue.length)\r\n\t\t\t\t\t\tthis.$refs.baseValue[0].focus();\r\n\t\t\t\t\telse\r\n\t\t\t\t\t\tthis.$refs.baseValue.focus();\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tDefaultClose()\r\n\t\t\t{\r\n\t\t\t},\r\n\t\t\tokClicked()\r\n\t\t\t{\r\n\t\t\t\tlet mergeResults = [];\r\n\t\t\t\tfor (let i = 0; i < this.mergeConflicts.length; i++)\r\n\t\t\t\t{\r\n\t\t\t\t\tlet conflict = this.mergeConflicts[i];\r\n\t\t\t\t\tlet result = { path: conflict.path, value: null, newOriginalValue: conflict.theirValue, isJson: conflict.isJson };\r\n\t\t\t\t\tif (conflict.selected === 0)\r\n\t\t\t\t\t\tresult.value = conflict.baseValue;\r\n\t\t\t\t\telse if (conflict.selected === 1)\r\n\t\t\t\t\t\tresult.value = conflict.yourValue;\r\n\t\t\t\t\telse if (conflict.selected === 2)\r\n\t\t\t\t\t\tresult.value = conflict.theirValue;\r\n\t\t\t\t\telse\r\n\t\t\t\t\t{\r\n\t\t\t\t\t\ttoaster.info(\"Please make a selection for all fields\");\r\n\t\t\t\t\t\treturn;\r\n\t\t\t\t\t}\r\n\t\t\t\t\tmergeResults.push(result);\r\n\t\t\t\t}\r\n\t\t\t\tthis.$emit(\"close\", { mergeResults });\r\n\t\t\t},\r\n\t\t\tcancelClicked()\r\n\t\t\t{\r\n\t\t\t\tthis.$emit(\"close\");\r\n\t\t\t},\r\n\t\t\twv(conflict, text)\r\n\t\t\t{\r\n\t\t\t\tif (conflict.isJson)\r\n\t\t\t\t\treturn text;\r\n\t\t\t\telse\r\n\t\t\t\t\treturn makeWhitespaceVisible(text);\r\n\t\t\t},\r\n\t\t\tselect(conflict, choice)\r\n\t\t\t{\r\n\t\t\t\tif (conflict.selected === choice)\r\n\t\t\t\t\tconflict.selected = -1;\r\n\t\t\t\telse\r\n\t\t\t\t\tconflict.selected = choice;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n\t/* unscoped */\r\n\t.wikEdDiffFragment\r\n\t{\r\n\t\tbackground: inherit;\r\n\t\tborder: inherit;\r\n\t\tfont-family: inherit;\r\n\t\tfont-size: inherit;\r\n\t\tline-height: inherit;\r\n\t\tbox-shadow: inherit;\r\n\t\tpadding: inherit;\r\n\t\tmargin: inherit;\r\n\t}\r\n\r\n\tdel\r\n\t{\r\n\t\tbackground-color: #ffa6a6 !important;\r\n\t\t/*text-decoration: none;*/\r\n\t\tfont-weight: bold;\r\n\t}\r\n\r\n\tins\r\n\t{\r\n\t\tbackground-color: #4dff4d !important;\r\n\t\tfont-weight: bold;\r\n\t}\r\n\r\n\t.paraSymbol\r\n\t{\r\n\t\topacity: 0.48;\r\n\t}\r\n</style>\r\n\r\n<style scoped>\r\n\t.inputDialogRoot\r\n\t{\r\n\t\tmax-width: calc(100vw - 40px);\r\n\t\tbackground-color: #FFFFFF;\r\n\t}\r\n\r\n\t.titleBar\r\n\t{\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tpadding: 8px 14px;\r\n\t\tbox-sizing: border-box;\r\n\t}\r\n\r\n\t.title\r\n\t{\r\n\t\ttext-align: center;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 16pt;\r\n\t}\r\n\r\n\t.dialogBody\r\n\t{\r\n\t\tpadding: 0px 5px 0px 5px;\r\n\t}\r\n\r\n\t.conflictsContainer\r\n\t{\r\n\t\tmargin-top: 1em;\r\n\t}\r\n\r\n\t.conflict\r\n\t{\r\n\t\tmargin-bottom: 1em;\r\n\t}\r\n\r\n\t\t.conflict:last-of-type\r\n\t\t{\r\n\t\t\tmargin-bottom: 0px;\r\n\t\t}\r\n\r\n\t.conflictPath\r\n\t{\r\n\t\tfont-weight: bold;\r\n\t\tmargin-bottom: 1em;\r\n\t\tbackground-color:;\r\n\t}\r\n\r\n\t.conflictValue\r\n\t{\r\n\t\tborder: 3px solid #E3E3E3;\r\n\t\tborder-left-width: 10px;\r\n\t\tmargin-bottom: 0.6em;\r\n\t\twhite-space: pre-wrap;\r\n\t\tcursor: pointer;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tborder-radius: 5px;\r\n\t\t/*box-shadow: -1px -1px 8px 1px rgba(0,0,0,0.4) inset;*/\r\n\t}\r\n\r\n\t\t.conflictValue.noneSelected\r\n\t\t{\r\n\t\t}\r\n\r\n\t\t.conflictValue.selected\r\n\t\t{\r\n\t\t\tborder-color: #000000;\r\n\t\t\tbox-shadow: 1px 1px 8px 2px rgba(0,0,0,1);\r\n\t\t\toutline: 1px solid black;\r\n\t\t}\r\n\r\n\t\t.conflictValue:hover,\r\n\t\t.conflictValue:focus\r\n\t\t{\r\n\t\t\toutline: 4px solid black;\r\n\t\t}\r\n\r\n\r\n\t.valueHeader\r\n\t{\r\n\t\tfont-size: 1.125em;\r\n\t\tbackground-color: #E3E3E3;\r\n\t}\r\n\r\n\t.conflictValue.selected .valueHeader\r\n\t{\r\n\t\tbackground-color: #000000;\r\n\t\tcolor: #FFFFFF;\r\n\t\tfont-weight: bold;\r\n\t}\r\n\r\n\t.conflictText\r\n\t{\r\n\t\tpadding: 0px 6px 8px 6px;\r\n\t}\r\n\r\n\t/*.baseValue\r\n\t{\r\n\t\tborder-color: #DDDDCD;\r\n\t}\r\n\r\n\t\t.baseValue .valueHeader\r\n\t\t{\r\n\t\t\tbackground-color: #DDDDCD;\r\n\t\t}\r\n\r\n\t.yourValue\r\n\t{\r\n\t\tborder-color: #D4D4DD;\r\n\t}\r\n\r\n\t\t.yourValue .valueHeader\r\n\t\t{\r\n\t\t\tbackground-color: #D4D4DD;\r\n\t\t}\r\n\r\n\t.theirValue\r\n\t{\r\n\t\tborder-color: #D4DDD4;\r\n\t}\r\n\r\n\t\t.theirValue .valueHeader\r\n\t\t{\r\n\t\t\tbackground-color: #D4DDD4;\r\n\t\t}*/\r\n\r\n\t.baseValue.selected\r\n\t{\r\n\t\tborder-color: #ffff00;\r\n\t}\r\n\r\n\t\t.baseValue.selected .valueHeader\r\n\t\t{\r\n\t\t\tbackground-color: #ffff00;\r\n\t\t\tcolor: #000000;\r\n\t\t}\r\n\r\n\r\n\t.yourValue.selected\r\n\t{\r\n\t\tborder-color: #7de3ff;\r\n\t}\r\n\r\n\t\t.yourValue.selected .valueHeader\r\n\t\t{\r\n\t\t\tbackground-color: #7de3ff;\r\n\t\t\tcolor: #000000;\r\n\t\t}\r\n\r\n\t.theirValue.selected\r\n\t{\r\n\t\tborder-color: #6fff6f;\r\n\t}\r\n\r\n\t\t.theirValue.selected .valueHeader\r\n\t\t{\r\n\t\t\tbackground-color: #6fff6f;\r\n\t\t\tcolor: #000000;\r\n\t\t}\r\n\r\n\t.buttons\r\n\t{\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t.dialogButton\r\n\t{\r\n\t\tmargin: 0px;\r\n\t\tborder: none;\r\n\t\tdisplay: inline-block;\r\n\t\tcursor: pointer;\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 12pt;\r\n\t\tbox-sizing: border-box;\r\n\t\tposition: relative;\r\n\t\tpadding: 12px 5px;\r\n\t\tflex: 1 0 auto;\r\n\t\ttext-align: center;\r\n\t}\r\n\r\n\t\t.dialogButton:hover\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,0,0.05);\r\n\t\t}\r\n\r\n\t.okButton\r\n\t{\r\n\t\tcolor: #4A9E42;\r\n\t}\r\n\r\n\t.cancelButton\r\n\t{\r\n\t\tcolor: #CE7D29;\r\n\t\tborder-left: 1px solid #DDDDDD;\r\n\t}\r\n\r\n\t.dialogButton:disabled\r\n\t{\r\n\t\topacity: 0.48;\r\n\t\tbackground-color: rgba(0,0,0,0.05);\t\r\n\t\tcolor: black;\r\n\t\tcursor: default;\r\n\t\tcursor: not-allowed;\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
